<template>
	<div>
		<div class="text-right">
			
		</div>

		<v-row class="mb-6">
			<v-col cols="7" md="5">
				<v-text-field
				v-model="serch_query"
				:placeholder="$lang.SUBSCRIPTION_HISTORY_SEARCH"
				outlined
				rounded
				dense
				@keyup="getSubscriptionHistory"
				append-icon="mdi-magnify"
				hide-details
				single-line
				></v-text-field>
			</v-col>
			<v-col cols="3" md="2">
				<v-btn  rounded depressed  outlined  class="download-svg-btn" width="151px" height="" @click="downloadCsv">
					<img src="@/assets/download.svg" alt="">
					{{$lang.DOWNLOAD_CSV}}
				</v-btn>
			</v-col>
			<v-col cols="2" md="2" >
				<div @click="openFilterDialog" class="cursor-pointer w-max-content ml-2">
					<filter-btn  :filter_count="filter_data.filter_count"/>
				</div>
			</v-col>
			<v-col cols="12" md="3" class="text-right">
				<span @click="$router.push({name:'add-new-subscription'})" class="cursor-pointer" v-if="$store.state.user_type!=$keys.WHOLESALER">
					<span class="secodry-text-4 mr-3">{{$lang.ADD_NEW_SUBSCRIPTION.toUpperCase()}}</span>
					<v-btn color="primary" fab small depressed >	
						<v-icon>mdi-plus</v-icon>
					</v-btn>
				</span>
			</v-col>

		</v-row>



		<v-data-table
		v-model="selected"
		:headers="headers"
		:items="sunsbscription_list"
		:hide-default-footer="true"
		:disable-sort="true"
		class="elevation-1 custome-header-bg custome-table-body"
		:loading="table_loading"
		item-key="order_id"
		show-select
		>
		<!-- plan -->
		<template v-slot:item.plan_name="{ item }">
			<div>
				{{item.plan_name}}<small class="fw-bold">({{item.amount}})</small>
			</div>
		</template>

		<!-- wholesaler -->
		<template v-slot:item.wholesaler="{ item }">
			<p>{{item.wholesaler_firm_name}}</p>
			<p> {{item.wholesaler_mobile_number}} </p>
		</template>

<!-- payment mode -->
		<template v-slot:item.payment_mode="{ item }">
			<p v-if="!item.is_free">{{item.payment_mode}}</p>
			<p v-else>-</p>
		</template>

		<!--  refernce id  -->
		<template v-slot:item.reference_id="{ item }">
			<div v-if="item.payment_mode==$keys.OPTION_CHEQUE">
				{{item.cheque_number}}
			</div>
			<div v-if="item.payment_mode==$keys.OPTION_NEFT">
				{{item.neft_imps_id}}
			</div>
			<div v-if="item.payment_mode==$keys.OPTION_PAYTM">
				-
			</div>

		</template>	
		<!-- action  -->
		<template v-slot:item.action="{ item }">

			<div v-if="item.status==$keys.INITIATED && item.payment_mode!=$keys.OPTION_PAYTM">
				<v-tooltip bottom>
					<template v-slot:activator="{ on, attrs }">
						<v-btn
						color="primary" fab small text @click="confirmationApprove(item)"
						v-bind="attrs"
						v-on="on"
						>
						<v-icon >mdi-check</v-icon>
					</v-btn>
				</template>
				<span>{{$lang.APPROVE}}</span>
			</v-tooltip>
			<v-tooltip bottom>
				<template v-slot:activator="{ on, attrs }">
					<v-btn
					color="error" fab small text @click="ShowConfirmationDialog(item,$keys.FAILED)"
					v-bind="attrs"
					v-on="on"
					class="ml-0"
					>
					<v-icon >mdi-close</v-icon>
				</v-btn>
			</template>
			<span>{{$lang.REJECT}}</span>
		</v-tooltip>
	</div>
	<div v-else>
		<span :class="item.status.toLowerCase()">{{item.status}}</span>
	</div>
</template>
<template v-slot:item.invoice="{ item }">
<div v-if="!item.is_free">
	<v-btn small fab text @click="downloadInvoice(item.order_id)" v-if="(item.status==$keys.SUCCESSFUL)">	
		<img src="@/assets/download.svg" alt="">	
	</v-btn>
</div>

</template>	
</v-data-table>

<v-pagination class="custome-pagination"  v-model="page_number" :total-visible="7" :length="total_page_count"
@input="getSubscriptionHistory"></v-pagination>

<confirm-accept-reject-dialog :dialog="dialog" :confirmSubsription="rejectSubsription"/>

<approve-subscription-dialog :dialog="approve_dialog" @approved="approveSubsription"/>

<subscription-history-filter :dialog="filter_dialog" :filter_data="filter_data"  @filter="getSubscriptionHistory" ref="subscription_history_filter"/>



</div>
</template>
<script>

import { mapGetters } from 'vuex';

export default{
	components: {
		ConfirmAcceptRejectDialog:()=> import('./child/ConfirmAcceptRejectDialog.vue'),
		subscriptionHistoryFilter:()=> import('./child/subscriptionHistoryFilter.vue'),
		ApproveSubscriptionDialog:()=> import('./child/ApproveSubscriptionDialog.vue'),
		FilterBtn :()=>import('@/components/common-components/FilterBtn.vue'),
	},
	data(){
		return{
			page_number:1,
			total_page_count:1,
			table_loading:false,
			serch_query:"",

			sunsbscription_list:[],
			selected:[],
			headers: [
			{ text: 'Transaction ID', value: 'order_id' },
			{ text: 'Purchased On', value: 'purchased_on',align:"center" },
			{ text: 'Wholesaler Info', value: 'wholesaler'},
			{ text: 'Plan', value: 'plan_name'},
			{ text: 'Payment Mode', value: 'payment_mode' },
			{ text: 'NEFT/IMPS ID/Cheque number', value: 'reference_id' },
			{ text: 'Action', value: 'action',width:"120px" },
			{ text: '', value: 'invoice' },
			],
			dialog:{
				flag:false,
				order_id:"",
				status:"",
				msg:""
			},
			approve_dialog:{
				flag:false,
				cheque_number:"",
				neft_ref_no:"",
			},
			/*FILTER*/
			filter_dialog:{
				flag:false
			},
			filter_data:{
				wholesaler_id_list:[],
				subscription_plan_id_list:[],
				payment_method_list:[],
				filter_date_from:"",
				filter_date_to:"",
				filter_count:0,
			},
		}
	},
	computed: mapGetters({
    subscription_filter_data: "user_subscription/getSubscriptionFilter",
  }),
	created(){
		this.getSubscriptionHistory(false);
	},
	methods:{
		/* Fetch  subscripiton  history list */ 
		getSubscriptionHistory(is_cancel=true){
			this.$store.dispatch('setPageLoader', true)
			const self=this
			let params={
				page_number:this.page_number,
				page_length:this.$keys.PAGE_LENGTH,
				search_query:this.serch_query,
				wholesaler_id_list:JSON.stringify(this.subscription_filter_data.wholesaler_id_list),
				filter_plan_id_list:JSON.stringify(this.subscription_filter_data.subscription_plan_id_list),
				filter_payment_method_list:JSON.stringify(this.subscription_filter_data.payment_method_list),
				filter_date_from:this.subscription_filter_data.filter_date_from,
				filter_date_to:this.subscription_filter_data.filter_date_to,
			};

			self.table_loading
			const successHandler = (response) => {
				if (response.data.success){
					self.sunsbscription_list=response.data.subscription_list
					self.total_page_count=response.data.total_page_count
				}
			};
			const finallyHandler = () => {
				this.$store.dispatch('setPageLoader', false)
				
			};
			self.request_GET( self,self.$urls.SUBSCRIPTON_HISTORY,params,successHandler,null,null,finallyHandler,is_cancel)
		},
		/* Open Confirmation Dialog */ 
		ShowConfirmationDialog(order,status){
			this.dialog.flag=true
			this.dialog.order_id=order.order_id
			this.dialog.status=status
			this.dialog.msg="want to Approve this Transaction"
			if (status==this.$keys.FAILED)
				this.dialog.msg="want to Reject this Transaction"

		},
		/* Open Confirmation Dialog */ 
		confirmationApprove(order){
			this.approve_dialog.flag=true
			this.approve_dialog.order=order
		},
		
		/* reject subscription request */
		rejectSubsription(){
			const self=this
			var	form = new FormData();
			form.append("order_id",self.dialog.order_id);
			form.append("status",self.dialog.status);
			const successHandler = (response) => {
				if(response.data.success){
					this.dialog.flag=false
					this.dialog.order_id=""
					this.dialog.status=""
					this.dialog.msg=""
					this.getSubscriptionHistory()
				}
			};
			const finallyHandler = () => {
			};
			this.request_POST(self,self.$urls.CONFIRM_OFFLINE_PAYMENT,form,successHandler,null,null,finallyHandler)

		},

		/* change the order status to the  confirm or rejected*/ 
		approveSubsription(order){
			const self=this

			// self.btn_loading=true
			var	form = new FormData();
			form.append("order_id",self.approve_dialog.order.order_id);
			form.append("status",self.$keys.SUCCESSFUL);
			form.append("cheque_id",self.approve_dialog.cheque_number);
			form.append("neft_imps_id",self.approve_dialog.neft_ref_no);


			const successHandler = (response) => {
				if(response.data.success){
					this.approve_dialog.flag=false
					this.dialog.order=null
					self.approve_dialog.cheque_number=""
					self.approve_dialog.neft_ref_no=""
					this.getSubscriptionHistory()
				}
			};
			const finallyHandler = () => {
				// self.btn_loading=false
			};

			this.request_POST(self,self.$urls.CONFIRM_OFFLINE_PAYMENT,form,successHandler,null,null,finallyHandler)

		},
		/* oprn filter dialog  set the values */ 
		openFilterDialog(){
			this.$refs.subscription_history_filter.setDisplayDate()
			this.$refs.subscription_history_filter.getWholesalerList()
			this.$refs.subscription_history_filter.getSubscriptionPlanList()
			this.filter_data.wholesaler_id_list=this.subscription_filter_data.wholesaler_id_list
			this.filter_data.subscription_plan_id_list=this.subscription_filter_data.subscription_plan_id_list
			this.filter_data.payment_method_list=this.subscription_filter_data.payment_method_list
			this.filter_data.filter_date_from=this.subscription_filter_data.filter_date_from
			this.filter_data.filter_date_to=this.subscription_filter_data.filter_date_tos
			this.filter_dialog.flag=true

		},
		/* Download CSV*/ 
		downloadCsv(){
			if(this.selected.length==0){
				this.showSnakeBar("warning",this.$messages.NO_SHIPMENT_SELECTED,)
				return false
			}

			let subscription_id_list=[]
			for (let i = 0; i < this.selected.length; i++) {
				subscription_id_list.push(this.selected[i].order_id)

			}
			subscription_id_list=JSON.stringify(subscription_id_list)


			window.open(this.$urls.BASE_URL+this.$urls.GET_SUBSCRIPTION_HISTORY_CSV+'?subscription_id_list='+subscription_id_list, "_blank"); 
		},
		/* download subscription invoice */ 
		downloadInvoice(subscription_id){
			this.$store.dispatch('setPageLoader', true)

			const self=this
			const reqListener = () => {
				if(xhr.status==200){
					var arrayBuffer = xhr.response;
					var fileURL = URL.createObjectURL(xhr.response);
					this.$store.dispatch('setPageLoader', false)
					
					window.open(fileURL);
				}
			};

			let url =this.$urls.BASE_URL+"transactions/get-pdf/?order_id="+subscription_id
			console.log(url)
			var xhr = new XMLHttpRequest();
			xhr.addEventListener("load", reqListener);
			xhr.open("GET", url); 
			xhr.responseType="blob"; 
			xhr.overrideMimeType("application/pdf; charset=x-user-defined");
			xhr.send(); 
			console.log(xhr)
		},

	}
}

</script>